import React from 'react';
import { C, openConfirm } from '@kineticdata/bundle-common';

// Class component for auto locking and unlocking using lifecycle methods
export class LockController extends React.Component {
  constructor(props) {
    super(props);
    // Timeout id used to prompt the user about an expiring lock
    this.promptTimeoutId = null;
    // Timeout id used to prompt to refetch the revision the after lock expires
    this.lockTimeoutId = null;
    // Has the user been prompted about an expiring lock
    this.prompted = false;
  }

  componentDidMount() {
    // If the revision is not locked (or it's locked by me) on mount,
    // lock it (or renew the lock)
    if (
      this.props.revision &&
      (!this.props.isLocked || this.props.isLockedByMe)
    ) {
      this.props.lockRevision({
        submissionId: this.props.revisionId,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      revisionId,
      entityId,
      revision,
      isLocked,
      isLockedByMe,
      lockTimeLeft,
      lockRevision,
      fetchRevision,
    } = this.props;

    // If the previous revision was locked by me on update, and the revision id
    // changed, unlock the previous one
    if (
      prevProps.revision &&
      prevProps.isLockedByMe &&
      prevProps.revisionId !== revisionId
    ) {
      prevProps.lockRevision({
        submissionId: prevProps.revisionId,
        unlock: true,
      });
    }
    // If the revision is not locked (or it's locked by me) on update, and the
    // revision id changed, lock it (or renew the lock)
    if (
      revision &&
      (!isLocked || isLockedByMe) &&
      prevProps.revisionId !== revisionId
    ) {
      lockRevision({ submissionId: revisionId });
    }

    // If locked by me, set timeout to prompt for lock timeout
    if (isLockedByMe && lockTimeLeft !== prevProps.lockTimeLeft) {
      this.promptTimeoutId = window.clearTimeout(this.promptTimeoutId);
      // If more than 2 minutes left, set timeout to prompt at 2 minute mark
      if (lockTimeLeft > C.REVISION_LOCK_PROMPT_TIME) {
        this.promptTimeoutId = window.setTimeout(() => {
          openConfirm({
            title: 'Renew Lock',
            body:
              'Your lock on this revision is about to expire. Would you like to renew it?',
            actionName: 'Renew Lock',
            ok: () => lockRevision({ submissionId: revisionId }),
          });
        }, lockTimeLeft - C.REVISION_LOCK_PROMPT_TIME);
      }
    }
    // If lock was lost, let the user know
    else if (!isLockedByMe && prevProps.isLockedByMe) {
      openConfirm({
        title: 'Lock Expired',
        body:
          'Your lock on this revision has expired. Would you like to try to obtain the lock again?',
        actionName: 'Obtain Lock',
        ok: () => lockRevision({ submissionId: revisionId }),
      });
    }

    // If locked by anyone, set timeout to refresh revision after lock expires
    if (isLocked && lockTimeLeft !== prevProps.lockTimeLeft) {
      this.lockTimeoutId = window.clearTimeout(this.lockTimeoutId);
      if (lockTimeLeft > 0) {
        this.lockTimeoutId = window.setTimeout(() => {
          fetchRevision(revisionId, entityId);
        }, lockTimeLeft);
      }
    }
  }

  componentWillUnmount() {
    // If the revision is lockedBy me on unmount, unlock it
    if (this.props.revision && this.props.isLockedByMe) {
      this.props.lockRevision({
        submissionId: this.props.revisionId,
        unlock: true,
      });
    }
    this.promptTimeoutId = window.clearTimeout(this.promptTimeoutId);
    this.lockTimeoutId = window.clearTimeout(this.lockTimeoutId);
  }

  render() {
    return null;
  }
}
